import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import {select, Store} from '@ngrx/store';
import {State} from '../../pages/Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Observer, of} from 'rxjs';
import {UserItem} from '../../pages/landingpage/user.model';
import {loadUserStart} from '../../pages/landingpage/store/actions/getUser.actions';
import {MitarbeiterItem} from '../../pages/Mitarbeiterverwaltung/mitarbeiter.model';
import {MitarbeiterFormdialogComponent} from '../../pages/Mitarbeiterverwaltung/components/mitarbeiter-form-dialog/mitarbeiter-formdialog.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {FirmaItem} from '../../pages/Mitarbeiterverwaltung/firma.model';
import {FirmaFormdialogComponent} from '../../pages/Mitarbeiterverwaltung/components/firma-form-dialog/firma-formdialog.component';
import { ResetPasswortFormComponent} from '../resetPasswort-form/resetPasswort-form.component';
import {HttpClient} from '@angular/common/http';
import {NewPasswortFormComponent} from '../newPasswort-form/newPasswort-form.component';
import {InformationFormComponent} from '../information-form/information-form.component';
import {SpesenartPageFormComponent} from '../../pages/Zeiterfassung/components/spesenart-pageForm/spesenart-pageform.component';
import {loadRollenStart} from '../../pages/Mitarbeiterverwaltung/store/actions/rolle.actions';
import {changeRolleStart} from '../../pages/Mitarbeiterverwaltung/store/actions/change-rolle.actions';
import {RollenverwaltungPageformComponent} from '../../pages/Mitarbeiterverwaltung/components/rollenverwaltung-pageForm/rollenverwaltung-pageform.component';
import {Security} from '../../security';
import {Layout} from '@src/app/layoutSize';

export interface MenuItem {
    href: string;
    isRouterLink: boolean;
    text: string;
    disabled?: Observable<boolean>;
    disabledOnPhone: boolean;
}

export interface LoginResponse{
  status: string;
  responce: any;
  message: string;
  feed: string;
}

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
    /**
     * Constructor of navbar component
     *
     * @param breakpointObserver - Observes window breakpoints
     */
    // tslint:disable-next-line:max-line-length variable-name
    constructor(public router: Router,
                private breakpointObserver: BreakpointObserver,
                private landingStore: Store<{ landingpage: State }>,
                public dialog: MatDialog,
                private mitarbeiterStore: Store<{ mitarbeiterverwaltung: State }>,
                public http: HttpClient,
                public security: Security,
                public layout: Layout,
    ) {

      this.$personalien = landingStore.pipe(select((state) => state.landingpage.items));
      this.$firma = mitarbeiterStore.pipe(select((state) => state.mitarbeiterverwaltung.firma.item));
      this.$rollen = mitarbeiterStore.pipe(select((state) => state.mitarbeiterverwaltung.userRollen.items));

      if (localStorage.getItem('userEmail') !== null) {
        this.loginForm.patchValue({
          email: localStorage.getItem('userEmail'),
        });
      }
    }
    @Input()
    public drawerTitle = '';

    @Input()
    public user: UserItem;

    @ViewChild('drawer') public drawer: MatSidenav;

    public showRollenverwaltung: Observable<boolean>;
    public showFirma: Observable<boolean>;
    public showProfile: Observable<boolean>;
    public showZeitverwaltung: Observable<boolean>;
    public showProjektverwaltung: Observable<boolean>;
    public showMitarbeiterverwaltung: Observable<boolean>;
    public showLandingpage: Observable<boolean>;

    public menuItems: MenuItem[];
    public isSmallDevice = false;

    public showHint: boolean;

    public loginResponse: LoginResponse;

    public rolleId: string;

    public $personalien;
    public $firma;
    public $rollen;

  public loginForm = new FormGroup({
    email: new FormControl('' , [Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZáéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
    passwort: new FormControl(),
  });
    /**
     *
     */
    public ngOnInit(): void {
      this.updateNavbar();
      this.mitarbeiterStore.dispatch(loadRollenStart());
      this.showHint = false;
      this.breakpointObserver
            .observe(localStorage.getItem('phoneWidth'))
            .pipe(map((result) => result.matches))
            .subscribe((isSmallDevice) => {
                if (this.isSmallDevice && !isSmallDevice && this.user.email !== null) {
                    this.drawer.close();
                }

                this.isSmallDevice = isSmallDevice;
            });
    }

    public updateNavbar(): void{
      this.layout.setLayoutSizes();
      // Alle Rechte von der Navigationsleiste werden gecheckt. Falls diese True sind wird dieses menuItem in der Navigationsleiste angezeigt. Sonst wird dieses versteckt.
      this.showRollenverwaltung = this.security.checkIfAllowed('5000');
      this.showProfile = this.security.checkIfAllowed('6000');
      this.showFirma = this.security.checkIfAllowed('6001');
      this.showZeitverwaltung = this.security.checkIfAllowed('3000');
      this.showProjektverwaltung = this.security.checkIfAllowed('2000');
      this.showMitarbeiterverwaltung = this.security.checkIfAllowed('1000');
      // Landingpage wird immer angezeigt
      this.showLandingpage = of(true);

      this.menuItems = [
        {
          href: '/landingpage',
          isRouterLink: true,
          text: 'navbar.landingpage',
          disabled: this.showLandingpage,
          disabledOnPhone: false,
        },
        {
          href: '/zeitverwaltung',
          isRouterLink: true,
          text: 'navbar.zeitverwaltung',
          disabled: this.showZeitverwaltung,
          disabledOnPhone: false,
        },
        {
          href: '/projektverwaltung',
          isRouterLink: true,
          text: 'navbar.projektverwaltung',
          disabled: this.showProjektverwaltung,
          disabledOnPhone: true,
        },
        {
          href: '/mitarbeiterverwaltung',
          isRouterLink: true,
          text: 'navbar.mitarbeiterverwaltung',
          disabled: this.showMitarbeiterverwaltung,
          disabledOnPhone: true,
        },
      ];

    }

  public editPersonalien(mitarbeiter: MitarbeiterItem): void {
      if (this.isSmallDevice){
          const dialogRef = this.dialog.open(MitarbeiterFormdialogComponent, {
            minWidth: '100vw',
            height: '100vh',
            data: {
              title: 'pages.mitarbeiterverwaltung.editpersonalien.title',
              submitButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.submitButtonLabel',
              cancelButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.cancelButtonLabel',
              id: mitarbeiter.id,
              anrede: mitarbeiter.anrede,
              name: mitarbeiter.name,
              vorname: mitarbeiter.vorname,
              email: mitarbeiter.email,
              passwort: mitarbeiter.passwort,
              geburtstag: mitarbeiter.geburtstag,
              mobile: mitarbeiter.mobile,
              rolle: mitarbeiter.rolle,
              ferientage: mitarbeiter.ferientage,
              anstellungprozent: mitarbeiter.anstellungprozent * 100,
              ort: mitarbeiter.ort,
              plz: mitarbeiter.plz,
              str1: mitarbeiter.str1,
              str2: mitarbeiter.str2,
              aktiv: mitarbeiter.aktiv,
              stundenProTag: mitarbeiter.stundenProTag
            },
          });
          dialogRef.afterClosed().subscribe();
      }
      else{
        const dialogRef = this.dialog.open(MitarbeiterFormdialogComponent, {

          data: {
            title: 'pages.mitarbeiterverwaltung.editpersonalien.title',
            submitButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.submitButtonLabel',
            cancelButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.cancelButtonLabel',
            id: mitarbeiter.id,
            anrede: mitarbeiter.anrede,
            name: mitarbeiter.name,
            vorname: mitarbeiter.vorname,
            email: mitarbeiter.email,
            passwort: mitarbeiter.passwort,
            geburtstag: mitarbeiter.geburtstag,
            mobile: mitarbeiter.mobile,
            rolle: mitarbeiter.rolle,
            ferientage: mitarbeiter.ferientage,
            anstellungprozent: mitarbeiter.anstellungprozent * 100,
            ort: mitarbeiter.ort,
            plz: mitarbeiter.plz,
            str1: mitarbeiter.str1,
            str2: mitarbeiter.str2,
            aktiv: mitarbeiter.aktiv,
            stundenProTag: mitarbeiter.stundenProTag
          },
        });
        dialogRef.afterClosed().subscribe();
      }
  }

  public editFirma(firma: FirmaItem): void {
      if(this.isSmallDevice){
            const dialogRef = this.dialog.open(FirmaFormdialogComponent, {
              minWidth: '100vw',
              height: '100vh',
              data: {
                title: 'pages.mitarbeiterverwaltung.editFirma.title',
                submitButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.submitButtonLabel',
                cancelButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.cancelButtonLabel',
                id: firma.id,
                email: firma.email,
                name: firma.name,
                telefon: firma.telefon,
                arbsol: firma.arbsol,
                branche: firma.branche,
                ort: firma.ort,
                plz: firma.plz,
                str1: firma.str1,
                str2: firma.str2
              },
            });
            dialogRef.afterClosed().subscribe();
      }
      else{
        const dialogRef = this.dialog.open(FirmaFormdialogComponent, {
          data: {
            title: 'pages.mitarbeiterverwaltung.editFirma.title',
            submitButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.submitButtonLabel',
            cancelButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.cancelButtonLabel',
            id: firma.id,
            email: firma.email,
            name: firma.name,
            telefon: firma.telefon,
            arbsol: firma.arbsol,
            branche: firma.branche,
            ort: firma.ort,
            plz: firma.plz,
            str1: firma.str1,
            str2: firma.str2
          },
        });
        dialogRef.afterClosed().subscribe();
      }
  }

  public resetPasswort(): void {
    const dialogRef = this.dialog.open(ResetPasswortFormComponent, {
      data: {
        title: 'pages.login.resetPasswortDialog.title',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.cancelButtonLabel',
      },
    });
    dialogRef.afterClosed().subscribe( result => {
      if (result){
        // Anzeigen von Informationsformular , email wurde gesendet blabla
        const okDialog = this.dialog.open(InformationFormComponent, {
          data: {
            title: 'pages.login.resetPasswortDialog.bestätigungTitle',
            text: 'pages.login.resetPasswortDialog.text'
          }
        });
      }
    });
  }


  public logout(): void {
    sessionStorage.clear();
    this.landingStore.dispatch(loadUserStart({email: ''}));
    window.location.reload();
  }

  public checkLogin(email: string, passwort: string): void{
      // Check if user exists and login
    this.http.get
    (
        `//local.curion.ch/myDay/backend/checkIfActiveUserExists.php?email=${email}`,
      {responseType: 'json'}
    ).subscribe((data: {data: {aktiv: number}}) => {
      // 0 == USER IST NICHT AKTIV
      if(data.data.aktiv == 0){
        // ERROR: USER NICHT AKTIV
        const okDialog = this.dialog.open(InformationFormComponent, {
          data: {
            title: 'Information',
            text: 'pages.login.errorDialog.text'
          }
        });
        email = '';
        passwort = '';
      }
      // HEISST AKTIV == NULL WAS BEDEUTET DAS DER USER NICHT EXISTIERT
      else if (data.data.aktiv != 1){
        // ERROR: USER EXISTIERT NICHT
        return;
      }
    });

    this.getUser(email, passwort).subscribe((data: LoginResponse) => {
      if (data?.responce === '0'){
        // Einloggen
        localStorage.setItem('userEmail', email);
        this.landingStore.dispatch(loadUserStart({email}));

        this.router.navigate(['zeitverwaltung']);
        this.updateNavbar();
      }
      else{
        // Passwort oder E-Mail ungültig
        this.showHint = true;
      }
    });
  }

  public changePasswort(email: string): void{

    if(this.isSmallDevice) {
    const dialogRef = this.dialog.open(NewPasswortFormComponent, {
      minWidth: '100vw',
      height: '100vh',
      data: {
        title: 'pages.login.newPasswortDialog.title',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.cancelButtonLabel',
        email,
      },
    });
    dialogRef.afterClosed().subscribe( result => {
      if (result){
        // Anzeigen von Informationsformular , email wurde gesendet blabla
        const okDialog = this.dialog.open(InformationFormComponent, {
          data: {
            title: 'pages.login.newPasswortDialog.successTitle',
            text: 'pages.login.newPasswortDialog.text'
          }
        });
      }
    });
    }
    else{
      const dialogRef = this.dialog.open(NewPasswortFormComponent, {
        data: {
          title: 'pages.login.newPasswortDialog.title',
          submitButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.submitButtonLabel',
          cancelButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.cancelButtonLabel',
          email,
        },
      });
      dialogRef.afterClosed().subscribe( result => {
        if (result){
          // Anzeigen von Informationsformular , email wurde gesendet blabla
          const okDialog = this.dialog.open(InformationFormComponent, {
            data: {
              title: 'pages.login.newPasswortDialog.successTitle',
              text: 'pages.login.newPasswortDialog.text'
            }
          });
        }
      });
    }

  }

  // Returns an observable with the login response, we need to subscribe to it to validate the results
  public getUser(email, passwort): any{
      return this.http.get<LoginResponse>
      (
        `https://local.curion.ch/AccMan/verify.php?app=1003&email=${email}&pwd=${passwort}`,
        {responseType: 'json'}
      );
  }

  public openSpesenverwaltung(): void{
    const dialogRef = this.dialog.open(SpesenartPageFormComponent, {
      data: {
        title: 'pages.zeitverwaltung.spesenverwaltung.title',
        submitButtonLabel: 'pages.projektverwaltung.addProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.addProjekt.cancelButtonLabel',
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  public openRollenverwaltung(): void{
      this.mitarbeiterStore.dispatch(loadRollenStart());
    const dialogRef = this.dialog.open(RollenverwaltungPageformComponent, {
      data: {
        title: 'pages.rollenverwaltung.title',
        submitButtonLabel: 'pages.projektverwaltung.addProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.addProjekt.cancelButtonLabel',
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  public changeRolle(rollenId: number): void{
    // Dispatch Action um Rolle des Users zu ändern
    this.mitarbeiterStore.dispatch(changeRolleStart({rolleId: rollenId}));
    // Weiterleitung zur Startseite
    this.router.navigate(['zeitverwaltung']);
    this.updateNavbar();
    return;
  }

}
